export function resourceColor(str: string | undefined | null) {
  if (!str) return "#000000";
  let hash = 0;
  let color = "#";

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 0xff;
    value = Math.floor((value + 255) / 2);
    color += ("00" + value.toString(16)).substr(-2);
  }
  return color;
}
